import customEventBus from '@common/scripts/libs/eventBus';
import { useLayoutEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import cookie from 'react-cookies';
gsap.registerPlugin(ScrollTrigger);
const markers = cookie.load('gsap_markers');
const useMenuScroll = () => {
    const refElement = useRef(null);
    const [ref, setRef] = useState(null);
    // const [submenu, setSubmenu] = useState(null);
    const [isSticky, setIsSticky] = useState(false);
    // const firstRender = useRef(true);
    // useLayoutEffect(() => {
    //   if (ref?.current && firstRender.current) {
    //     const refPositionEl = document.createElement('div');
    //     refPositionEl.id = 'ref-position-el';
    //     ref.current.insertAdjacentElement('beforebegin', refPositionEl);
    //     setSubmenu(refPositionEl);
    //     firstRender.current = false;
    //   }
    //   return () => {
    //     setSubmenu(null);
    //   };
    // }, []);
    useLayoutEffect(() => {
        if (ref) {
            refElement.current = ref;
            ScrollTrigger.create({
                id: 'submenus-animation',
                trigger: '#ref-position-el',
                start: 'clamp(top top)',
                scrub: false,
                onEnter: () => {
                    setIsSticky(true);
                    customEventBus.on('header:onprogress', (data) => {
                        gsap.set(ref, {
                            top: data.scroll + data.height - 1, //adjusting little space between subnav and header
                        });
                    });
                },
                onEnterBack: () => {
                    setIsSticky(false);
                    customEventBus.off('header:onprogress', () => {
                        gsap.set(ref, {
                            top: 0, //adjusting little space between subnav and header
                        });
                    });
                },
                markers,
            });
        }
        return () => {
            var _a;
            (_a = ScrollTrigger.getById('submenus-animation')) === null || _a === void 0 ? void 0 : _a.kill();
        };
    }, [ref]);
    return { ref: setRef, refElement: refElement, isSticky };
};
export default useMenuScroll;
